(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.PopulationTab = (function(superClass) {
    extend(PopulationTab, superClass);

    function PopulationTab() {
      return PopulationTab.__super__.constructor.apply(this, arguments);
    }

    PopulationTab.prototype.init = function() {
      var self, sidebar;
      self = this;
      sidebar = $(this.layoutSelector);
      this.subHandlers = {
        'Population': {
          'class': 'portal::handlers/weightings/PopulationDialog'
        }
      };
      this.taffyObjects = this.parent.taffyObjects;
      sidebar.find('#sel_pop_pp').on('change', (function(_this) {
        return function() {
          var sub;
          _this.toggleProdZoneWarning();
          sub = _this.createSubHandler('Population');
          if (sub) {
            sub.loadLayoutPostOptions = {
              pp_id: sidebar.find('#sel_pop_pp').val()
            };
            return sub.init();
          }
        };
      })(this));
      sidebar.find('#sel_pop_pp').trigger('change');
      return this.toggleProdZoneWarning();
    };

    PopulationTab.prototype.toggleProdZoneWarning = function() {
      var pp_id, pw, sidebar;
      sidebar = $(this.layoutSelector);
      pp_id = parseInt(sidebar.find('#sel_pop_pp').val());
      if (pp_id) {
        pw = this.taffyObjects.pw({
          placement_programs_id: pp_id
        }).first();
        if (pw.enable_grower_ranges) {
          return sidebar.find('#prod_zone_warning').hide();
        } else {
          return sidebar.find('#prod_zone_warning').show();
        }
      }
    };

    PopulationTab.prototype.destroy = function() {
      return PopulationTab.__super__.destroy.call(this, false);
    };

    return PopulationTab;

  })(Handler);

}).call(this);
